export default __webpack_public_path__ + "static/media/27.837b0d95.wav";